import { CSSProperties } from 'react';

export const cardGrid: CSSProperties = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '16px 8px',
  justifyContent: 'space-between',
};

export const card: CSSProperties = {
  flex: '1 1 calc(33.33% - 16px)',
  minWidth: 'calc(33.33% - 16px)',
  maxWidth: 'calc(33.33% - 16px)',
  display: 'flex',
  alignItems: 'strech',
  justifyContent: 'center',
  boxShadow: '0px 1px 2px 0px #0B0C0C29',
};

export const dummyCard: CSSProperties = {
  flex: '1 1 calc(33.33% - 16px)',
  minWidth: 'calc(33.33% - 16px)',
  maxWidth: 'calc(33.33% - 16px)',
  display: 'flex',
  alignItems: 'strech',
  visibility: 'hidden',
  justifyContent: 'center',
};
